import { Typography } from "antd"
import classNames from "classnames"
import type { ComponentProps } from "react"
import styles from "./index.css"

const TEXT_COLOR_TOKENS = new Map([
  ["primary", "var(--ant-color-primary)"],
  ["secondary", "var(--ant-color-text-secondary)"],
])

export type TextSize = "s" | "m" | "l" | number

export type TextProps = Omit<
  ComponentProps<typeof Typography.Text>,
  "color" | "size"
> & {
  color?: string
  size?: TextSize
}

export const Text = ({
  className,
  color,
  size,
  style,
  ...props
}: TextProps) => {
  const textColor = color ? (TEXT_COLOR_TOKENS.get(color) ?? color) : undefined

  return (
    <Typography.Text
      {...props}
      className={classNames(className, {
        [styles.s]: size === "s",
        [styles.m]: size === "m",
        [styles.l]: size === "l",
      })}
      style={{
        color: textColor,
        fontSize: typeof size === "number" ? size : undefined,
        ...style,
      }}
    />
  )
}
